import { render } from "./RadioField.vue?vue&type=template&id=5c8f79d1"
import script from "./RadioField.vue?vue&type=script&lang=js"
export * from "./RadioField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__